import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <span
              className="text-2xl font-heading font-bold text-accent-600"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              52吃瓜网
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`whitespace-nowrap px-4 py-2 text-sm rounded-full transition-colors ${
                location.pathname === '/'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`whitespace-nowrap px-4 py-2 text-sm rounded-full transition-colors ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`whitespace-nowrap px-4 py-2 text-sm rounded-full transition-colors ${
                location.pathname === '/about'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href="#app-download"
              className="whitespace-nowrap px-5 py-2 bg-accent-500 text-background-50 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer"
            >
              App下载
              <i className="ri-arrow-right-line ml-1"></i>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className={`whitespace-nowrap px-4 py-3 text-sm rounded-lg ${
                location.pathname === '/'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`whitespace-nowrap px-4 py-3 text-sm rounded-lg ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`whitespace-nowrap px-4 py-3 text-sm rounded-lg ${
                location.pathname === '/about'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
            <a
              href="#app-download"
              className="whitespace-nowrap px-5 py-3 bg-accent-500 text-background-50 rounded-lg text-sm font-medium text-center hover:bg-accent-600 transition-colors cursor-pointer mt-2"
            >
              App下载
              <i className="ri-arrow-right-line ml-1"></i>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}